import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-black border-t border-gray-800" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-gray-900 to-black border-2 border-green-500 rounded-xl p-4 md:p-6 text-center relative overflow-hidden" data-id="element-77">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,rgba(34,197,94,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-78"></div>
          <div className="relative z-10" data-id="element-79">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-green-500/10 rounded-full mb-3 border border-green-500/30" data-id="element-80">
              <ShieldCheckIcon className="w-7 h-7 text-green-500" data-id="element-81" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-82">
              Tu compra está protegida
            </h2>
            <h3 className="text-lg md:text-xl font-bold text-green-500 mb-2 uppercase tracking-wider" data-id="element-83">
              Garantía de satisfacción de 7 días
            </h3>
            <div className="space-y-1 text-base md:text-lg text-gray-300 max-w-xl mx-auto" data-id="element-84">
              <p data-id="element-85">
                Probá el material, revisalo y evaluá si realmente te ayuda en tu
                preparación.
              </p>
              <p data-id="element-86">
                Si dentro de los primeros 7 días sentís que este pack no era
                para vos, podés pedir la devolución.
              </p>
              <p className="text-white font-bold mt-2 text-lg md:text-xl" data-id="element-87">
                Comprás con tranquilidad y sin riesgo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}